module.exports = __webpack_public_path__ + "assets/4ae9d1269b992e155b66eeca34a0462d.ttf";